import { render, staticRenderFns } from "./modalCrearCategoria.vue?vue&type=template&id=1196670c"
import script from "./modalCrearCategoria.vue?vue&type=script&lang=js"
export * from "./modalCrearCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports